import { alterDate } from '@hc-frontend/utils'

function lastDateByPeriod(startDate, period) {
  return alterDate({ date: startDate, days: period - 1 })
}

export default lastDateByPeriod
